import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import BasicTableStackable from 'components/basic/table/BasicTableStackable';
import TextNumber from 'components/basic/text/TextNumber';
import { formatDateTime } from 'lib/date';
import { formatUsd } from 'lib/display/formatting';
import { useSelector } from 'reduxState/store';

import BalanceTransactionChain from './BalanceTransactionChain';
import BalanceTransactionStatuses from './BalanceTransactionStatuses';

import type { PendingDepositItem } from 'reduxState/balances/pendingDepositTypes';

const TypeWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

type Params = {
  pendingDeposits: PendingDepositItem[];
  onSelectRow: (transaction: PendingDepositItem) => void;
};

export default function PendingBalancesTable({
  pendingDeposits,
  onSelectRow,
}: Params) {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const isMobile = useSelector(state => state.screen.isMobile);
  return (
    <BasicTableStackable
      notFixedLayout
      stripes
      getItemKey={transaction => `${transaction.time}_${transaction.quantity}`}
      firstColumnPaddingLeft="10px"
      onRowClick={isMobile ? item => onSelectRow(item) : undefined}
      columns={() => {
        return [
          {
            name: 'Date',
            render: deposit => formatDateTime(deposit.time),
          },
          {
            name: 'Type',
            fontFamily: 'standard',
            render: (
              <TypeWrap>
                <MaterialSymbol
                  icon="arrow_downward"
                  color="var(--green7)"
                  fontSize="small"
                />{' '}
                &nbsp;&nbsp;Deposit
              </TypeWrap>
            ),
            stackWithPrevious: isMobile,
          },
          {
            name: 'Quantity',
            align: isMobile ? 'right' : 'left',
            render: deposit => (
              <>
                <TextNumber value={formatUsd(deposit.quantity)} /> USDC
              </>
            ),
          },
          {
            name: 'Chain',
            fontFamily: 'standard',
            render: isMobile
              ? false
              : deposit => <BalanceTransactionChain transaction={deposit} />,
          },
          // { name: 'Bridge',
          //   fontFamily: 'standard',
          //   render: isMobile ? false : deposit => <BalanceTransactionBridge transaction={deposit} />,
          //   stackWithPrevious: isMobile },
          {
            name: 'Status',
            fontFamily: 'standard',
            align: 'right',
            render: deposit => (
              <BalanceTransactionStatuses transaction={deposit} />
            ),
            stackWithPrevious: isMobile,
          },
          // {
          //   name: '',
          //   fontFamily: 'standard',
          //   width: EXPAND_COLUMN_WIDTH,
          //   render: isMobile ? <ExpandColumnIcon /> : false,
          // },
        ];
      }}
      errorText={
        !walletAddress
          ? 'Connect wallet to see your pending balance'
          : pendingDeposits.length === 0
          ? 'No pending balances.'
          : undefined
      }
      items={pendingDeposits}
    />
  );
}
